import {IPromoBanner} from "modules/types";
import {PromoName} from "modules/enums";
import fantasyBackground from "assets/images/promoBanner/fantasyBackground.svg";
import fantasyDailyBackground from "assets/images/promoBanner/fantasyDailyBackground.svg";
import bracketPredictorBackground from "assets/images/promoBanner/bracketPredictorBackground.svg";
import matchPredictorBackground from "assets/images/promoBanner/matchPredictorBackground.svg";
import whoamiBackground from "assets/images/promoBanner/whoamiBackground.svg";

const GAMEZONE_PROMO: IPromoBanner = {
	backgroundColor: "#061121",
	textColor: "#FFF",
	buttonBackground: "#1199FA",
	buttonColor: "#FFF",
	buttonHover: "#1199FA",
	buttonLink: "/",
	buttonText: "promo_banner.playzone.button_view",
	title: "promo_banner.playzone.title",
	description: "promo_banner.playzone.desc",
};

const FANTASY_CLASSIC_PROMO: IPromoBanner = {
	backgroundColor: "#00CFB7",
	backgroundImage: fantasyBackground,
	textColor: "#550065",
	buttonBackground: "#550065",
	buttonColor: "#FFF",
	buttonHover: "#873EB4",
	buttonLink: "/fantasy-classic/team",
	buttonText: "promo_banner.fantasy.button_play",
	title: "promo_banner.fantasy.title",
	description: "promo_banner.fantasy.desc",
};

const FANTASY_DAILY_PROMO: IPromoBanner = {
	backgroundColor: "#550065",
	backgroundImage: fantasyDailyBackground,
	textColor: "#FFF",
	buttonBackground: "#F54500",
	buttonColor: "#FFF",
	buttonHover: "#F54500",
	buttonLink: "/fantasy-daily/team",
	buttonText: "promo_banner.daily.button_play",
	title: "promo_banner.daily.title",
	description: "promo_banner.daily.desc",
};

const BRACKET_PREDICTOR_PROMO: IPromoBanner = {
	backgroundColor: "#FF004C",
	backgroundImage: bracketPredictorBackground,
	textColor: "#FFF",
	buttonBackground: "#00CFB7",
	buttonColor: "#8A1538",
	buttonHover: "#00CFB7",
	buttonLink: "/bracket-predictor/brackets",
	buttonText: "promo_banner.bracket_predictor.button_predict",
	title: "promo_banner.bracket_predictor.title",
	description: "promo_banner.bracket_predictor.desc",
};

const TRIVIA_PROMO: IPromoBanner = {
	backgroundColor: "#061121",
	textColor: "#FFF",
	buttonBackground: "#00E99D",
	buttonColor: "#03122B",
	buttonHover: "#00E99D",
	buttonLink: "/trivia",
	buttonText: "promo_banner.trivia.button_play",
	title: "promo_banner.trivia.title",
	description: "promo_banner.trivia.desc",
};

const CONTENT_BRACKET_PROMO: IPromoBanner = {
	backgroundColor: "#061121",
	textColor: "#FFF",
	buttonBackground: "#00E99D",
	buttonColor: "#03122B",
	buttonHover: "#00E99D",
	buttonLink: "/content-bracket",
	buttonText: "promo_banner.cb.button_vote",
	title: "promo_banner.cb.title",
	description: "promo_banner.cb.desc",
};

const FIVES_PROMO: IPromoBanner = {
	backgroundColor: "#061121",
	textColor: "#FFF",
	buttonBackground: "#1199FA",
	buttonColor: "#FFF",
	buttonHover: "#1199FA",
	buttonLink: "/fives",
	buttonText: "promo_banner.fives.button_play",
	title: "promo_banner.fives.title",
	description: "promo_banner.fives.desc",
};

const HYUNDAI_QUIZ_PROMO: IPromoBanner = {
	backgroundColor: "#061121",
	textColor: "#FFF",
	buttonBackground: "#1199FA",
	buttonColor: "#FFF",
	buttonHover: "#1199FA",
	buttonLink: "/hyundai-quiz",
	buttonText: "promo_banner.sustainability_quiz.button_play",
	title: "promo_banner.sustainability_quiz.title",
	description: "promo_banner.sustainability_quiz.desc",
};

const MATCH_PREDICTOR_PROMO: IPromoBanner = {
	backgroundColor: "#F54500",
	backgroundImage: matchPredictorBackground,
	textColor: "#FFF",
	buttonBackground: "#550065",
	buttonColor: "#FFF",
	buttonHover: "#873EB4",
	buttonLink: "/match-predictor/match",
	buttonText: "promo_banner.match_predictor.button_predict",
	title: "promo_banner.match_predictor.title",
	description: "promo_banner.match_predictor.desc",
};

const BUDWEISERPOTM_PROMO: IPromoBanner = {
	backgroundColor: "#DC0019",
	textColor: "#FFF",
	buttonBackground: "#0A0541",
	buttonColor: "#FFF",
	buttonHover: "#0A0541",
	buttonLink: "/budweiserpotm",
	buttonText: "promo_banner.bud.button_vote",
	title: "promo_banner.bud.title",
	description: "promo_banner.bud.desc",
};

const WHOAMI_PROMO: IPromoBanner = {
	backgroundColor: "#8A1538",
	backgroundImage: whoamiBackground,
	textColor: "#FFF",
	buttonBackground: "#FF004C",
	buttonColor: "#FFF",
	buttonHover: "#FF3470",
	buttonLink: "/whoami/game",
	buttonText: "promo_banner.who.button_guess",
	title: "promo_banner.who.title",
	description: "promo_banner.who.desc",
};

const COCA_COLA_PROMO: IPromoBanner = {
	backgroundColor: "#F10000",
	textColor: "#FFF",
	buttonBackground: "#000000",
	buttonColor: "#FFF",
	buttonHover: "#000000",
	buttonLink:
		"https://www.fifa.com/fifaplus/en/articles/qatar2022-notifications-multiple-teams-en",
	buttonText: "promo_banner.cocacola.button_view",
	title: "promo_banner.cocacola.title",
	description: "promo_banner.cocacola.desc",
};

const GOTT_PROMO: IPromoBanner = {
	backgroundColor: "#002C5F",
	textColor: "#FFF",
	buttonBackground: "#36F597",
	buttonColor: "#002C5F",
	buttonHover: "#36F597",
	buttonLink: "/gott",
	buttonText: "promo_banner.gott.button_vote",
	title: "promo_banner.gott.title",
	description: "promo_banner.gott.desc",
};

const BEST_AWARDS_PROMO: IPromoBanner = {
	backgroundColor: "#061121",
	textColor: "#FFF",
	buttonBackground: "#00E99D",
	buttonColor: "#03122B",
	buttonHover: "#00E99D",
	buttonLink: "https://www.fifa.com/fifaplus/en/the-best-fifa-football-awards",
	buttonText: "promo_banner.best.button_play",
	title: "promo_banner.best.title",
	description: "promo_banner.best.desc",
};

export const PROMO_BANNER: Record<PromoName, IPromoBanner> = {
	[PromoName.GameZone]: GAMEZONE_PROMO,
	[PromoName.Trivia]: TRIVIA_PROMO,
	[PromoName.Fantasy]: FANTASY_CLASSIC_PROMO,
	[PromoName.FantasyDaily]: FANTASY_DAILY_PROMO,
	[PromoName.BracketsPredictor]: BRACKET_PREDICTOR_PROMO,
	[PromoName.Brackets]: CONTENT_BRACKET_PROMO,
	[PromoName.Fives]: FIVES_PROMO,
	[PromoName.HyundaiQuiz]: HYUNDAI_QUIZ_PROMO,
	[PromoName.MatchPredictor]: MATCH_PREDICTOR_PROMO,
	[PromoName.Budweiserpotm]: BUDWEISERPOTM_PROMO,
	[PromoName.WhoAmI]: WHOAMI_PROMO,
	[PromoName.CocaCola]: COCA_COLA_PROMO,
	[PromoName.GOTT]: GOTT_PROMO,
	[PromoName.FIFABestAwards]: BEST_AWARDS_PROMO,
};
